import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { AbstractToggleFormComponent, EditablePanelComponent } from '@spike/scaffolds';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { AsyncApiService } from '@spike/core';
import { FormArray } from '@angular/forms';
import { WorkPhase } from 'src/app/features/workflow/models/workphase.model';
import { PositionWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { PositionWorkingPhaseFormComponent } from "../../forms/position-working-phase-form/position-working-phase-form";


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-working-phase-general-toggle-panel',
  providers:[],
  imports: [EditablePanelComponent, PositionWorkingPhaseFormComponent],
  templateUrl: './working-phase-general-toggle-panel.html'
})
export class WorkingPhaseGeneralTogglePanel extends AbstractToggleFormComponent<WorkPhase>{

  // Inject
  private readonly asyncApi = inject(AsyncApiService);
  private readonly formFactory = inject(FormFactoryService);

  // Input
  public readonly data = input.required<WorkPhase>();
  
  // Output
  public readonly onSave = output<WorkPhase|undefined>();

  // State 
  public readonly workflowPhase=computed(()=>{
    const data = this.data();
    return data.phase;
  });

  public readonly title=computed(()=>{
    const workflowPhase = this.workflowPhase();
    return PositionWorkflow.list!.find(x => x.workingPhase == workflowPhase)?.label ?? '';
  });

  public readonly workflowState=computed(()=>{
    const workflowPhase = this.workflowPhase();
    return PositionWorkflow.list!.find(x => x.workingPhase == workflowPhase)
  });

  //forms
  public readonly form = this.formFactory.createWorkphaseForm();

  override disabledFields= computed(()=>{
    const data = this.data();
    const workflowState = this.workflowState();
    if(!data || !workflowState) return [];
    return workflowState?.list?.find(x=>x.id == data?.stateId)?.disabledFields??[];
  })

  public readonly isReadOnly= computed(()=>{
    const data = this.data();
    const workflowState = this.workflowState();
    if(!data || !workflowState) return false;
    return !!workflowState?.list?.find(x=>x.id == data?.stateId)?.readonly;
  })



  async save() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const generalValues = this.form.getRawValue();
      const toSaveData: any = {
        ...generalValues,
      };

      await this.asyncApi.save<WorkPhase>(EntityApiEnum.WORKPHASE, toSaveData, this.data()!.phaseId);
      this.onUpdate();
    }
  }

  public onUpdate(){
    this.onSave.emit(this.data())
  }

  get operationsArray(): FormArray { return this.form.get('operations') as FormArray;  }
  get toolsArray(): FormArray { return this.form.get('tools') as FormArray;  }
  get materialsArray(): FormArray { return this.form.get('materials') as FormArray;  }

  protected override buildFormArrays(data: WorkPhase): void {
    
    this.fillFormArray(this.operationsArray, data.operations,  (op) => this.formFactory.createPositionOperationForm(op));
    this.fillFormArray(this.materialsArray, data.materials, (mat) => this.formFactory.createMaterialForm(mat));
    this.fillFormArray(this.toolsArray, data.tools, (tool) => this.formFactory.createToolForm(tool));
  }

}